import {
  MolsonBox,
  MolsonButton,
  MolsonIcon,
  MolsonTypography
} from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'

type WarningMessageProps = {
  onClose?: () => void
  secondaryText?: string
  text: string
}
export const WarningMessage = ({
  onClose,
  secondaryText,
  text
}: WarningMessageProps) => {
  const theme = molsonUseTheme()
  return (
    <MolsonBox
      sx={{
        backgroundColor: theme.palette.secondary.warningLight,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        position: 'relative'
      }}
    >
      <MolsonBox
        alignItems="center"
        display="flex"
        justifyContent="space-between"
      >
        <MolsonBox display="flex" gap={1}>
          <MolsonIcon variant="WARNING" iconColor="warning" />
          <MolsonBox display="flex" flexDirection="column">
            <MolsonTypography
              sx={{ color: theme.palette.secondary.warning }}
              variant="h4"
            >
              {text}
            </MolsonTypography>
            {secondaryText ? (
              <MolsonTypography
                color={theme.palette.secondary[600]}
                fontWeight={600}
                variant="body2"
              >
                {secondaryText}
              </MolsonTypography>
            ) : null}
          </MolsonBox>
        </MolsonBox>
      </MolsonBox>
      {onClose ? (
        <MolsonButton
          startIcon={
            <MolsonIcon
              dataTestId="close-icon"
              onClick={onClose}
              variant="CLOSE_X"
            />
          }
          color="secondary"
          hasIconOnly={true}
          sx={{ position: 'absolute', right: 6, top: 6 }}
          variant="text"
        />
      ) : null}
    </MolsonBox>
  )
}
